// extracted by css-extract-rspack-plugin
export default {"iconWrap":"iconWrap-mis0PI","icon":"icon-wz5Zxh"};